// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2BFET","buttons":"PendingPaymentAlert_buttons__2i-pI"};